import './navbar.css';
import { NavLink } from "react-router-dom";

export default function Navbar() {

	return(
		<nav className = "navbar">
			<NavLink className={nav => (nav.isActive ? 'navbloc active' : "navbloc" )} to = "/" >Home</NavLink>
			<NavLink className={nav => (nav.isActive ? 'navbloc active' : "navbloc" )} to = "/CodingProjects">Coding Projects</NavLink>
			<NavLink className={nav => (nav.isActive ? 'navbloc active' : "navbloc" )} to = "/VideogameProjects">Video Game Projects</NavLink>
			<NavLink className={nav => (nav.isActive ? 'navbloc active' : "navbloc" )} to = "/AnimationProjects">Animation Projects</NavLink>
			<NavLink className={nav => (nav.isActive ? 'navbloc active' : "navbloc" )}  to = "/3DAssetProjects">3D Asset Project Gallery</NavLink>
			<a href="./Resume-Hershbja.pdf" target = "_blank" className='navbloc'>Resume</a>
		</nav>
	);
}